// @flow
import { useContext } from 'react';

import { EstimateContext } from '../contexts/EstimateContext';

import { getStarterCommitLimits } from './useStarterCommitLimits';

// Package bounds the saved estimate currently breaks (e.g. sized above the package maximum), as
// reported by the backend. Empty when the estimate is within bounds or not on a starter package.
export const getStarterCommitViolations = (estimate) =>
  getStarterCommitLimits(estimate)?.violations ?? [];

export const useStarterCommitViolations = () => {
  const estimate = useContext(EstimateContext);
  return getStarterCommitViolations(estimate);
};
